const u = navigator.userAgent;
const common = {
  env: API_CONFIG.ENV, //环境 0测试 1正式 2本地
  appId: 'wxa60f4a433d867c90',
}
export default common;
